import { MobileOutlined, UserOutlined } from "@ant-design/icons";
import { FingerprintOutlined } from "@mui/icons-material";
import CloseIcon from "@mui/icons-material/Close";
import { useEffect, useState } from "react";
import { Col, Row } from "react-bootstrap";
import { useParams } from "react-router-dom";
import Select from "react-select";
import { Button } from "reactstrap";
import {
  useGetBlockByDistrictQuery,
  useGetDistrictByStateQuery,
  useGetStatesQuery,
} from "services/locationApiSlice";
import swal from "sweetalert";
import { useUpdateEmployeeMutation } from "../UserManagementApiSlice";

const AssingProjectLocation = ({
  employeeDataRefetch,
  employeeData,
  addProjectModel,
}) => {
  const emp_id = useParams("id").id;

  const [selectedCbbo, setSelectedCbbo] = useState({});
  const [selectedFpo, setSelectedFpo] = useState({});
  const [stateId, setStateId] = useState("");
  const [districtId, setDistrictId] = useState("");
  const [stateList, setStateList] = useState([]);
  const [districtList, setDistrictList] = useState([]);
  const [blockList, setBlockList] = useState([]);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [projectAssignments, setProjectAssignments] = useState({});

  const { data: getStates } = useGetStatesQuery();
  const { data: dataDistrict } = useGetDistrictByStateQuery(stateId);
  const { data: dataBlock } = useGetBlockByDistrictQuery(districtId);
  const [updateEmployee] = useUpdateEmployeeMutation(emp_id);

  useEffect(() => {
    if (getStates !== undefined) {
      setStateList(getStates?.data?.results);
    }
  }, [getStates]);

  useEffect(() => {
    if (dataDistrict !== undefined) {
      setDistrictList(dataDistrict?.data?.results);
    }
  }, [dataDistrict]);

  useEffect(() => {
    if (dataBlock != undefined) {
      setBlockList(dataBlock?.data?.results);
    }
  }, [dataBlock]);

  useEffect(() => {
    const cbboData = JSON.parse(localStorage.getItem("selectedCbbo") || "{}");
    const fpoData = JSON.parse(localStorage.getItem("selectedFpo") || "{}");
    setSelectedCbbo(cbboData);
    setSelectedFpo(fpoData);
  }, []);

  const customStyles = {
    control: (base) => ({
      ...base,
      minHeight: 46,
    }),
  };

  const handleRemove = (id, type) => {
    const updated = { ...(type === "cbbo" ? selectedCbbo : selectedFpo) };
    delete updated[id];

    localStorage.setItem(
      type === "cbbo" ? "selectedCbbo" : "selectedFpo",
      JSON.stringify(updated)
    );
    type === "cbbo" ? setSelectedCbbo(updated) : setSelectedFpo(updated);
  };

  const handleZoneChange = (selectedOption, orgId) => {
    setProjectAssignments((prev) => ({
      ...prev,
      [orgId]: {
        zone: selectedOption.value,
        zoneCodes: [],
        zoneNames: [],
      },
    }));
  };

  const ZoneOptions = [
    { value: "state", label: "State" },
    { value: "district", label: "District" },
    { value: "block", label: "Block" },
  ];

  const handleStateOptions = () => {
    let responseAgentArray = [];
    stateList.map((state) => {
      responseAgentArray.push({
        value: state.state_code,
        label: state.state_name,
        ConditionName: "state",
      });
    });
    return responseAgentArray;
  };

  const handleDistrictOptions = () => {
    let responseAgentArray = [];
    districtList.map((district) => {
      responseAgentArray.push({
        value: district.district_code,
        label: district.district_name,
        ConditionName: "district",
      });
    });
    return responseAgentArray;
  };

  const handleBlockOptions = () => {
    let responseAgentArray = [];
    blockList.map((block) => {
      responseAgentArray.push({
        value: block.block_code,
        label: block.block_name,
        ConditionName: "block",
      });
    });
    return responseAgentArray;
  };

  const onLocationChange = async (selected, orgId, type) => {
    if (!selected) return;

    let codes = [];
    let names = [];

    if (Array.isArray(selected)) {
      codes = selected.map((item) => item.value);
      names = selected.map((item) => item.label);
    } else {
      codes = [selected.value];
      names = [selected.label];
    }

    let updatedAssignment = {
      ...projectAssignments[orgId],
      zoneCodes: codes,
      zoneNames: names,
    };

    if (type === "state") {
      setDistrictId("");
      setBlockList([]);
      setStateId(selected.value);
      updatedAssignment.state_options = selected;
    }

    if (type === "district") {
      setDistrictId(selected.value);

      updatedAssignment.district_options = selected;
    }

    if (type === "block") {
      updatedAssignment.block_options = selected;
    }

    setProjectAssignments((prev) => ({
      ...prev,
      [orgId]: updatedAssignment,
    }));
  };

  const handleSubmit = () => {
    setIsSubmitting(true);
    let assignedProjects = [];
    const errors = [];

    const existingProjects = Array.isArray(employeeData?.assigned_project)
      ? employeeData?.assigned_project
      : [];
    assignedProjects = [...existingProjects];

    const buildAssignedProject = (data, type) => {
      for (const [id, info] of Object.entries(data)) {
        const assignment = projectAssignments[id];

        if (!assignment?.zone) {
          errors.push(
            `Please select Assigned Zone for "${info.organization_name}"`
          );
          continue;
        }

        if (
          ["state", "district", "block"].includes(assignment.zone) &&
          (!assignment.zoneCodes || assignment.zoneCodes.length === 0)
        ) {
          errors.push(
            `Please select at least one ${assignment.zone} for "${info.organization_name}"`
          );
          continue;
        }

        const newProject = {
          id: id,
          name: info.organization_name,
          assigned_zone: assignment.zone,
          assigned_zone_names: assignment.zoneNames,
          assigned_zone_codes: assignment.zoneCodes,
          state_options: assignment.state_options,
          district_options: assignment.district_options,
          block_options: assignment.block_options,
        };

        const existingIndex = assignedProjects.findIndex(
          (proj) => proj.id === id
        );

        if (existingIndex !== -1) {
          assignedProjects[existingIndex] = newProject;
        } else {
          assignedProjects.push(newProject);
        }
      }
    };

    buildAssignedProject(selectedCbbo, "cbbo");
    buildAssignedProject(selectedFpo, "fpo");

    if (errors.length > 0) {
      swal({
        icon: "warning",
        title: "Missing Information",
        text: errors.join("\n"),
      });
      setIsSubmitting(false);
      return;
    }

    updateEmployee({
      id: emp_id,
      payload: {
        assigned_project: assignedProjects,
      },
    })
      .unwrap()
      .then((data) => {
        if (data?.success) {
          swal("Employee Data Updated Successfully", {
            buttons: false,
            icon: "success",
            title: "Data Updated",
            timer: 1500,
          });
          employeeDataRefetch();
          addProjectModel(false);
          localStorage.removeItem("selectedCbbo");
          localStorage.removeItem("selectedFpo");
        } else {
          swal("Missing Fields", {
            buttons: false,
            icon: "warning",
            title: "Please fill Full Details",
            timer: 1500,
          });
        }
      })
      .catch((e) => {
        console.error("Update Error:", e);
        swal("Error occurred", {
          buttons: false,
          icon: "error",
          title: "Something went wrong",
          timer: 3000,
        });
      })
      .finally(() => {
        setIsSubmitting(false);
      });
  };

  const renderCards = (data, type) =>
    Object.entries(data).map(([id, info]) => {
      const currentAssignment = projectAssignments[id] || {};
      return (
        <div key={id} className="col-lg-6 ">
          <div className="card shadow-md ">
            <div className="p-3">
              <div className=" d-flex justify-content-between align-items-start">
                <div>
                  <div className="mb-2">
                    <FingerprintOutlined
                      size={12}
                      className="me-2 text-secondary"
                    />
                    <strong>ID:</strong> {id}
                  </div>
                  <div className="mb-2">
                    <UserOutlined size={14} className="me-2 text-primary" />
                    <strong>Name:</strong> {info.organization_name}
                  </div>
                  <div>
                    <MobileOutlined size={14} className="me-2 text-success" />
                    <strong>Phone:</strong> {info.phone_number}
                  </div>
                </div>

                <CloseIcon
                  size={28}
                  className="cursor text-danger"
                  onClick={() => handleRemove(id, type)}
                />
              </div>

              <div className="mt-2">
                <Row>
                  <Col lg="6" className="mb-3">
                    <label className="text-black mb-1">
                      Assigned Zone <span className="text-danger">*</span>
                    </label>
                    <Select
                      options={ZoneOptions}
                      placeholder="Select Zone"
                      value={
                        ZoneOptions.find(
                          (option) => option.label === currentAssignment.zone
                        ) || undefined
                      }
                      onChange={(e) => handleZoneChange(e, id)}
                      styles={customStyles}
                    />
                  </Col>
                  {(currentAssignment.zone === "state" ||
                    currentAssignment.zone === "district" ||
                    currentAssignment.zone === "block") && (
                    <Col
                      lg={currentAssignment.zone === "state" ? "12" : "6"}
                      className="mb-3"
                    >
                      <label className="text-black mb-1"> State</label>
                      <Select
                        isMulti={
                          currentAssignment.zone === "state" ? true : false
                        }
                        options={handleStateOptions()}
                        onChange={(selected) =>
                          onLocationChange(selected, id, "state")
                        }
                        placeholder="Select State"
                        styles={customStyles}
                      />
                    </Col>
                  )}

                  {(currentAssignment.zone === "district" ||
                    currentAssignment.zone === "block") && (
                    <Col lg="12" className="mb-3 ">
                      <label className="text-black mb-1"> District</label>
                      <Select
                        isMulti={
                          currentAssignment.zone === "district" ? true : false
                        }
                        menuPlacement="auto"
                        options={handleDistrictOptions()}
                        onChange={(selected) =>
                          onLocationChange(selected, id, "district")
                        }
                        placeholder="Select District"
                        styles={customStyles}
                      />
                    </Col>
                  )}

                  {currentAssignment.zone === "block" && (
                    <Col lg="12" className="mb-4 z-0 ">
                      <label className="text-black mb-2"> Block</label>
                      <Select
                        isMulti={
                          currentAssignment.zone === "block" ? true : false
                        }
                        menuPlacement="auto"
                        options={handleBlockOptions()}
                        onChange={(selected) =>
                          onLocationChange(selected, id, "block")
                        }
                        styles={customStyles}
                      />
                    </Col>
                  )}
                </Row>
              </div>
            </div>
          </div>
        </div>
      );
    });
  return (
    <div className=" mt-4">
      <div className="row">
        {Object.keys(selectedCbbo).length === 0 &&
        Object.keys(selectedFpo).length === 0 ? (
          <div className="alert alert-info text-center w-100">
            <h5>No CBBO/ FPO Selected</h5>
            <p className="mt-2">
              Please go to <strong>Step 1</strong> and select to continue.
            </p>
          </div>
        ) : (
          <>
            {Object.keys(selectedCbbo).length > 0 && (
              <div className="mb-3 w-100">
                <h5 className="mb-3">Selected CBBOs</h5>
                <div className="row d-flex">
                  {renderCards(selectedCbbo, "cbbo")}
                </div>
              </div>
            )}

            {Object.keys(selectedFpo).length > 0 && (
              <div className="mb-3 w-100">
                <h5 className="mb-3">Selected FPOs</h5>
                <div className="row d-flex">
                  {renderCards(selectedFpo, "fpo")}
                </div>
              </div>
            )}
          </>
        )}
      </div>

      {(Object.keys(selectedCbbo).length > 0 ||
        Object.keys(selectedFpo).length > 0) && (
        <div className="d-flex justify-content-end mt-3">
          <Button
            color="success"
            className="saathi-submit-btn px-4"
            onClick={handleSubmit}
            disabled={isSubmitting}
            size="sm"
          >
            {isSubmitting ? "Submitting..." : "Submit"}
          </Button>
        </div>
      )}
    </div>
  );
};

export default AssingProjectLocation;
